export const decrypt = async (base64Data, customKey) => {
  try {
    //console.log('🔐 Step 1: Base64 encrypted input:', base64Data);
    //console.log('🗝️ Step 1: Secret key (raw):', customKey);

    // Step 1: Convert customKey to SHA-256 hash (32-byte)
    const encoder = new TextEncoder();
    const keyData = encoder.encode(customKey);
    const hashBuffer = await crypto.subtle.digest('SHA-256', keyData);
    //console.log('🔑 Step 2: SHA-256 hashed key:', Array.from(new Uint8Array(hashBuffer)).map(b => b.toString(16).padStart(2, '0')).join(''));

    // Step 2: Convert base64 to ArrayBuffer
    const binaryData = atob(base64Data);
    const buffer = new Uint8Array([...binaryData].map(c => c.charCodeAt(0)));
    //console.log('📦 Step 3: Decoded binary buffer (hex):', [...buffer].map(b => b.toString(16).padStart(2, '0')).join(''));

    // Step 3: Extract IV and ciphertext
    const iv = buffer.slice(0, 16);
    const encryptedData = buffer.slice(16);
    //console.log('🧩 Step 4: IV (hex):', [...iv].map(b => b.toString(16).padStart(2, '0')).join(''));
    //console.log('🧩 Step 4: Encrypted data (hex):', [...encryptedData].map(b => b.toString(16).padStart(2, '0')).join(''));

    // Step 4: Import key into WebCrypto
    const cryptoKey = await crypto.subtle.importKey(
      'raw',
      hashBuffer,
      { name: 'AES-CBC' },
      false,
      ['decrypt']
    );
    //console.log('🔐 Step 5: CryptoKey imported');

    // Step 5: Decrypt
    const decryptedBuffer = await crypto.subtle.decrypt(
      { name: 'AES-CBC', iv },
      cryptoKey,
      encryptedData
    );
    const decoder = new TextDecoder();
    const dataDecrypt = decoder.decode(decryptedBuffer);
    //console.log('✅ Step 6: Decryption successful:', dataDecrypt);

    return dataDecrypt;
  } catch (err) {
    //console.error('❌ Decryption failed:', err.message);
    return null;
  }
};
